import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './components/Home';
import Admin from "./pages/Admin";




function App() {
  
  return (
    <div className="App">

      <BrowserRouter basename="/staking">
        <ToastContainer pauseOnFocusLoss={false} />
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/admin" element={<Admin />} />
        </Routes>
        <Footer />

      </BrowserRouter>
      
    </div>
  );
}

export default App;
